var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.anexos.length > 0
        ? _c(
            "el-collapse",
            _vm._l(_vm.anexos, function(item, indexItem) {
              return _c(
                "el-collapse-item",
                { key: indexItem, attrs: { title: _vm.formatTitle(item) } },
                [
                  _c(
                    "el-card",
                    [
                      _c("el-row", [
                        _c("b", [_vm._v("Responsável:")]),
                        _c("br"),
                        _c("span", [_vm._v(_vm._s(item.nome_responsavel))])
                      ]),
                      _c("br"),
                      _c("el-row", [
                        _c("b", [_vm._v("Motivo do vínculo:")]),
                        _c("br"),
                        _c("span", [_vm._v(_vm._s(item.motivo_vinculo))])
                      ]),
                      _c(
                        "el-row",
                        [
                          _c("listagem-documentos", {
                            attrs: {
                              documentos: [item],
                              ownerDocumento: "GESTAO_DOCUMENTOS"
                            }
                          })
                        ],
                        1
                      ),
                      _c("br"),
                      _c("el-row", [
                        _c("b", [_vm._v("Data do vínculo:")]),
                        _c("br"),
                        _c("span", [
                          _vm._v(_vm._s(_vm.formatDate(item.data_vinculo)))
                        ])
                      ])
                    ],
                    1
                  ),
                  item.data_cancelamento
                    ? _c(
                        "el-card",
                        { staticClass: "edicao" },
                        [
                          _c("h2", [_vm._v("Cancelamento")]),
                          _c("el-row", [
                            _c("b", [_vm._v("Responsável:")]),
                            _c("br"),
                            _c("span", [
                              _vm._v(_vm._s(item.responsavel_cancelamento))
                            ])
                          ]),
                          _c("br"),
                          _c("el-row", [
                            _c("b", [_vm._v("Data do cancelamento:")]),
                            _c("br"),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.getDateHour(item.data_cancelamento))
                              )
                            ])
                          ]),
                          _c("br"),
                          _c("el-row", [
                            _c("b", [_vm._v("Justificativa do cancelamento:")]),
                            _c("br"),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  item.justificativa_cancelamento
                                )
                              }
                            })
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._l(item.log_edicoes, function(log, indexCard) {
                    return item.data_edicao
                      ? _c(
                          "el-card",
                          { key: indexCard, staticClass: "edicao" },
                          [
                            _c("h2", [_vm._v("Edição")]),
                            _c("el-row", [
                              _c("b", [_vm._v("Responsável:")]),
                              _c("br"),
                              _c("span", [_vm._v(_vm._s(log.nomeUsuario))])
                            ]),
                            _c("br"),
                            _c("el-row", [
                              _c("b", [_vm._v("Data da edição:")]),
                              _c("br"),
                              _c("span", [
                                _vm._v(_vm._s(_vm.getDateHour(log.data)))
                              ])
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  })
                ],
                2
              )
            }),
            1
          )
        : _c("span", { staticClass: "center" }, [
            _vm._v("Nenhum documento anexado.")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f5b1a28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f5b1a28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppVisualizarAnexosTab.vue
// module id = null
// module chunks = 